module.exports = __webpack_public_path__ + "static/img/fz_thb_what.c5de44a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_thb_what.png
// module id = 7Yd5
// module chunks = 0